import React from "react";
import styled from "styled-components";
import get from "lodash/get";

import CameraAltIcon from "@mui/icons-material/CameraAlt";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Badge from "@mui/material/Badge";

import Button from "../shared/Button";
import EstateItemHeader from "./EstateItemHeader";
import EstateSubDetails from "./EstateSubDetails";
import RelatedContacts from "./RelatedContacts";

const EstateItem = ({ estate, showDetail }) => {
  const {
    id,
    name,
    address,
    number,
    box,
    floor,
    zip,
    city,
    country,
    displayStatusId,
    purpose,
    purposeStatus,
    price,
    currency,
    pictures = [],
    category,
    contacts,
    canHaveChildren,
    parentId,
    uploadedDocuments,
  } = estate;

  const isProject = canHaveChildren && !parentId;
  const computedAddress = [address, number, box, floor]
    .filter(Boolean)
    .join(" ");
  const fullAddress = [computedAddress, zip, city].filter(Boolean).join(", ");
  const imageUrl = get(pictures, [0, "urlSmall"], "");

  return (
    <StyleWrapper className="estate__list__item d-flex align-items-center">
      <div className="estate__list__item-img">
        <img src={imageUrl} alt="" />
        <span className={`purpose purpose-${get(purpose, "id")}`}>
          {get(purpose, "name")}
        </span>
        <span className="pictures">
          <CameraAltIcon htmlColor="var(--white)" />
          {pictures.length}
        </span>
      </div>
      <div className="estate__list__item-info align-self-start">
        <EstateItemHeader
          id={id}
          name={name}
          category={get(category, "name")}
          purposeStatus={get(purposeStatus, "name")}
          displayStatusId={displayStatusId}
          fullAddress={fullAddress}
          country={get(country, "name")}
          onClickTitle={showDetail}
          price={price}
          currency={currency}
          displayPurposeStatus
          isProject={isProject}
          isUnitView
        />
        <EstateSubDetails estate={estate} />
        <div className="estate__list__item-info__footer d-flex justify-content-between align-items-center">
          <RelatedContacts contacts={contacts} />
          <div className="action-btn-container d-flex">
            {/* <Button color="primary" variant="contained" icon={<UploadIcon />}>
              Télécharger un fichier
            </Button> */}
            {/* <DocumentMenu /> */}
            <Badge
              badgeContent={uploadedDocuments}
              slotProps={{
                badge: {
                  sx: {
                    color: "var(--white)",
                    backgroundColor: "var(--red-color)",
                  },
                },
              }}
            >
              <Button
                color="success"
                variant="contained"
                icon={<PostAddIcon />}
                onClick={() => showDetail(id)}
              >
                Document
              </Button>
            </Badge>
          </div>
        </div>
      </div>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  &.estate__list__item {
    height: 212px;
    border-radius: 12px;
    background-color: var(--white);
    padding: 15px;
    margin: 0 15px;
    box-shadow: 0px 0px 10px -6px rgba(130, 130, 130, 1);

    &:first-child {
      margin-top: 10px;
    }

    &:last-child {
      margin-bottom: 10px;
    }

    .estate__list__item-img {
      position: relative;

      img {
        width: 284px;
        height: 182px;
        border-radius: 3px;
      }

      & .purpose {
        position: absolute;
        top: 10px;
        left: 10px;
        border-radius: 3px;
        padding: 2px 10px;

        color: var(--white);
        background-color: var(--red-color);
        text-transform: capitalize;
        font-size: 13px;
        font-weight: 700;

        &.purpose-2 {
          background-color: var(--blue-dark);
        }

        &.purpose-3 {
          // TODO: confirmer la couleur du background pour la vente en viager
        }
      }

      & .pictures {
        position: absolute;
        display: flex;
        align-items: center;
        left: 10px;
        bottom: 10px;
        color: var(--white);
        font-size: 10px;

        & > svg {
          font-size: 12px;
          margin-right: 5px;
        }
      }
    }

    .estate__list__item-info {
      margin-left: 30px;
      margin-right: 15px;
      flex-grow: 1;

      .estate-header {
        padding-bottom: 5px;
        border-bottom: 1px solid var(--menu-active-color);
      }
    }

    .sub-details {
      padding: 8px 0;
      border-bottom: 1px solid var(--menu-active-color);
    }

    .action-btn-container {
      gap: 10px;
    }

    .estate__list__item-info__footer {
      margin-top: 10px;
    }
  }
`;

export default EstateItem;
